// Código JavaScript personalizado del tema

// ── Subscription cart guard ──────────────────────────────────────────────────
// Works for both the main product page AND the quick-add modal.
// The submit interceptor lives at document level (capture phase) so it catches
// ALL add-to-cart forms — including those injected dynamically by quick-add.js.
(function () {
  var bypassSubmit = false;

  function cartHasSubscription(productId, cart) {
    return cart.items.some(function (item) {
      return item.product_id === productId && item.selling_plan_allocation != null;
    });
  }

  function fetchCart() {
    return fetch('/cart.js').then(function (r) { return r.json(); });
  }

  // Find the nearest product-form ancestor and return its context
  function getGuardContext(form) {
    var productFormEl = form.closest('product-form');
    if (!productFormEl || !productFormEl.dataset.productId) return null;

    var productId = parseInt(productFormEl.dataset.productId, 10);
    // Submit button: query within scope (works for both page and modal)
    var submitBtn = productFormEl.querySelector('button[name="add"]');
    // Warning element: scoped query works regardless of dynamic ID prefixing
    var warningEl = productFormEl.querySelector('.subscription-cart-warning');

    return { productFormEl: productFormEl, productId: productId, submitBtn: submitBtn, warningEl: warningEl };
  }

  // Subscription radios live in sibling blocks OUTSIDE product-form.
  // Climb to the nearest .wt-product wrapper which contains both form and radios.
  function getScope(productFormEl) {
    return productFormEl.closest('.wt-product') || document;
  }

  function isSubscriptionSelectedIn(productFormEl) {
    var scope = getScope(productFormEl);
    var checked = scope.querySelector('input[name="selling_plan"]:checked');
    console.log('[SubscriptionGuard] isSubscriptionSelected scope:', scope.className || 'document', '| checked:', checked);
    return !!(checked && checked.dataset.radioType === 'selling_plan');
  }

  function setBlockedFor(ctx, blocked) {
    console.log('[SubscriptionGuard] setBlocked:', blocked, '| productId:', ctx.productId);
    if (ctx.submitBtn) {
      ctx.submitBtn.disabled = blocked;
      ctx.submitBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
    }
    if (ctx.warningEl) ctx.warningEl.hidden = !blocked;
  }

  // ── DOCUMENT-LEVEL CAPTURE: intercepts ALL add-to-cart form submits ────────
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;

    console.log('[SubscriptionGuard] submit capturado | bypassSubmit:', bypassSubmit, '| form:', form.id);

    if (bypassSubmit) {
      bypassSubmit = false;
      console.log('[SubscriptionGuard] ✅ Bypass activo — dejando pasar a product-form.js');
      return;
    }

    var ctx = getGuardContext(form);
    if (!ctx) {
      console.warn('[SubscriptionGuard] No se encontró product-form con data-product-id');
      return;
    }

    if (!isSubscriptionSelectedIn(ctx.productFormEl)) {
      console.log('[SubscriptionGuard] No es suscripción — dejando pasar');
      return;
    }

    // Block while doing live cart check
    e.preventDefault();
    e.stopImmediatePropagation();
    console.log('[SubscriptionGuard] Suscripción detectada — consultando carrito...', '| productId:', ctx.productId);

    fetchCart().then(function (cart) {
      var alreadySubscribed = cartHasSubscription(ctx.productId, cart);
      console.log('[SubscriptionGuard] alreadySubscribed:', alreadySubscribed,
        '| items:', cart.items.map(function(i){ return {id: i.product_id, sp: !!i.selling_plan_allocation}; }));

      if (alreadySubscribed) {
        console.log('[SubscriptionGuard] 🚫 BLOQUEADO');
        setBlockedFor(ctx, true);
      } else {
        console.log('[SubscriptionGuard] ✅ OK — re-dispatching submit');
        setBlockedFor(ctx, false);
        bypassSubmit = true;
        form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      }
    });

  }, true /* capture phase */);

  // ── UI REFRESH: disable button if subscription already in cart ────────────
  function refreshUIForForm(productFormEl) {
    if (!productFormEl || !productFormEl.dataset.productId) return;
    if (productFormEl.dataset.guardInit) return; // Avoid duplicate radio listeners
    productFormEl.dataset.guardInit = 'true';

    var productId = parseInt(productFormEl.dataset.productId, 10);
    var submitBtn = productFormEl.querySelector('button[name="add"]');
    var warningEl = productFormEl.querySelector('.subscription-cart-warning');

    console.log('[SubscriptionGuard] Inicializando UI para productId:', productId,
      '| submitBtn:', submitBtn, '| warningEl:', warningEl);

    function refresh() {
      fetchCart().then(function (cart) {
        var isSubscription = isSubscriptionSelectedIn(productFormEl);
        var blocked = cartHasSubscription(productId, cart) && isSubscription;
        console.log('[SubscriptionGuard] refreshUI → productId:', productId, '| blocked:', blocked);
        if (submitBtn) {
          submitBtn.disabled = blocked;
          submitBtn.setAttribute('aria-disabled', blocked ? 'true' : 'false');
        }
        if (warningEl) warningEl.hidden = !blocked;
      });
    }

    refresh();

    var scope = getScope(productFormEl);
    scope.querySelectorAll('input[name="selling_plan"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        console.log('[SubscriptionGuard] Radio changed:', radio.dataset.radioType);
        refresh();
      });
    });
  }

  function initAll() {
    console.log('[SubscriptionGuard] initAll — buscando product-form[data-product-id]');
    document.querySelectorAll('product-form[data-product-id]').forEach(refreshUIForForm);
  }

  // On page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // When quick-add modal injects the product form (quick-add.js dispatches this after 150ms)
  document.addEventListener('subscription:reinit', function () {
    console.log('[SubscriptionGuard] subscription:reinit — re-inicializando para el modal');
    initAll();
  });

})();

